import { useContext, useState } from 'react';
import useEventsTracker from '../../tracking/useEventsTracker';
import useRecentFilterSetsHandler from './useRecentFilterSetsHandler';
import useContextActions from '../../../../useContextActions';

const useListHandler = ({ Context, onSelect }) => {
  const {
    state: { filterSets }
  } = useContext(Context);
  const [filterSetToEdit, setFilterSetToEdit] = useState(null);
  const [filterSetToDelete, setFilterSetToDelete] = useState(null);
  const eventsTracker = useEventsTracker({ Context });
  const { updateRecentFilterSetIds } = useRecentFilterSetsHandler(Context);
  const contextActions = useContextActions({ Context });

  const isListEmpty = Object.values(filterSets)?.length === 0;

  const onSelectFilterSet = async filterSet => {
    await contextActions.onSelectFilterSet(filterSet);
    onSelect();
    updateRecentFilterSetIds(filterSet?.id);
    eventsTracker.onSelectFilterSet(filterSet);
  };

  return {
    filterSetToEdit,
    setFilterSetToEdit,
    filterSetToDelete,
    setFilterSetToDelete,
    onSelectFilterSet,
    isListEmpty
  };
};

export default useListHandler;
